import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Entry } from './Entry';
import { offlineEntries } from './data/offlineEntries';

@Injectable({
  providedIn: 'root',
})
export class EntryService {
  constructor() {}

  public entries = new BehaviorSubject<Entry[]>([]);

  put(entry: Entry): Promise<void> {
    throw new Error('Method not implemented.');
  }

  post(entry: Entry): Promise<void> {
    throw new Error('Method not implemented.');
  }

  delete(id: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
}
